import jwtDecode from "jwt-decode";

/**
 * Check if the decoded JWT token has admin role.
 * Supports multiple claim formats from the backend.
 */
export const isAdminRole = (decoded) => {
    if (!decoded) return false;
    return (
        (Array.isArray(decoded.role) &&
            decoded.role.some(
                (r) =>
                    r.authority === "ROLE_ADMIN" || r === "ROLE_ADMIN" || r === "ADMIN"
            )) ||
        decoded.role === "ROLE_ADMIN" ||
        decoded.role === "ADMIN" ||
        decoded.isAdmin === true
    );
};

/**
 * Decode token and return role information.
 * Returns { isAdmin, decoded } or null if token is invalid.
 */
export const getRoleFromToken = (token) => {
    if (!token) return null;
    try {
        const decoded = jwtDecode(token);
        return {
            isAdmin: isAdminRole(decoded),
            decoded,
        };
    } catch (error) {
        console.error("JWT decode error:", error);
        return null;
    }
};
